import * as fromRootReducer from '../../modules/root-reducer';
import * as fromUser from '../../modules/user';
import { initRUM } from '../../../utils/aws-rum';

/*
   If we login via SSO on another site then  we don't have the user 
   information we need to decide on routes etc. 
   This middleware will load it as soon as possible.
*/

export const middleware = ({
  getIsAuthenticated,
  getUserLoaded,
  fetchUser,
  getIdToken,
}) => store => {
  let isAwaitingUser = false;
  let fetchPromise = Promise.resolve();
  let rumInitStarted = false;
  return next => async action => {
    const state = store.getState();

    if( isAwaitingUser ) {
      await(fetchPromise);
      return next(action);
    }

    if( getIsAuthenticated(state) && ! isAwaitingUser && ! getUserLoaded(state) ){
      isAwaitingUser = true;

      fetchPromise = store.dispatch(fetchUser());

      await fetchPromise;
      isAwaitingUser = false;
    }

    const result = next(action);

    if (!rumInitStarted && getIsAuthenticated(store.getState())) {
      rumInitStarted = await initRUM({
        getIdToken: () => getIdToken(store.getState()),
      });
    }

    return result;
  };
};


export default middleware({
  getIsAuthenticated: fromRootReducer.getIsAuthenticated,
  getUserLoaded: fromRootReducer.getUserLoaded,
  fetchUser: fromUser.justFetchUser,
  getIdToken: fromRootReducer.getIdToken,
});
